
<template>
    <div>
      <router-view />
    </div>
</template>



<script>

// 引入自适应方案
import flexible from "flexible.js";

// 基准字号配置（单位：px）
const MOBILE_FLEXIBLE_WIDTH = 850;
const PC_FLEXIBLE_WIDTH = 700;

const FLEXIBLE_HEIGHT = 450;
const PC_MAX_WIDTH = 328;

// 通过 UA 判断是否为桌面端（非移动端）
const getIsDesktopUA = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isMobileUA =
    /mobile|android|iphone|ipod|ipad|windows phone|iphone os|iemobile|blackberry|opera mini/i.test(
      userAgent
    );
  return !isMobileUA;
};

// H5 文字尺寸换算基准配置
const flexibleWidth = getIsDesktopUA() ? PC_FLEXIBLE_WIDTH : MOBILE_FLEXIBLE_WIDTH;
const maxwidth = getIsDesktopUA() ? PC_MAX_WIDTH : FLEXIBLE_HEIGHT;
flexible(flexibleWidth, maxwidth);


export default {
  name: "home",
  data() {
    return {
      name: "home",
    };
  },
  components: {
   
  },
  setup(){
  
  },
  mounted(){
    // this.nav.UpdateMenuInfo();
  },
  methods: {
    // testin(){
    //   let that=this;
    // }
   
  },
};
</script>


<style scoped="scoped" lang="scss">
  .leftnav{
    background-color: #fff;
    width: 160px;
  }
</style>

  